import { css, SerializedStyles } from '@emotion/react';

export const useStyles = (theme): SerializedStyles => css`
  .drawer {
    width: 240px;
    margin-top: 54px;
    height: calc(100% - 54px);

    ${theme.breakpoints.up('sm')} {
      margin-top: 64px;
      height: calc(100% - 64px);
    }
  }

  .drawer-container {
    background-color: ${theme.palette.white};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: ${theme.spacing(2)};
  }

  .divider {
    margin: ${theme.spacing(2, 0)};
  }

  .nav {
    margin-bottom: ${theme.spacing(2)};
  }
`;
